<template>
	<div>
		<div v-if="['error','info','success','warning'].includes(type)" class="alert alert-dismissible notify" :class="{
			'alert-danger' : type === 'error',
			'alert-info' : type === 'info',
			'alert-success' : type === 'success',
			'alert-warning' : type === 'warning'}">

			<button type="button" class="close" @click="close()">
				<span aria-hidden="true">&times;</span>
			</button>
			<strong class="title">{{title}}</strong>
			<br />
			<span v-html="message"></span>
		</div>
		<div v-if="type === 'connection'" class="connection-alert">
			<div class="row">
				<div class="col-lg-3">
					<div class="bg-connect">
						<i class="fa fa-plug"></i>
					</div>
				</div>
				<div class="col-lg-9">
					<div class="txt-area">
						<button type="button" class="close" @click="close()">
							<span aria-hidden="true">&times;</span>
						</button>
						<strong class="title">{{title}}</strong>
						<br />
						<span v-html="message"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			default: "success"
		},
		title: {
			default: "Store Created"
		},
		message: {
			default:
				"The store Orange Shop has been successfully added to the database"
		},
		id: {
			default: ''
		}
	},
	methods: {
		close() {
			Event.$emit('notification:close',{id: this.id})
		}
	}
};
</script>

<style lang="scss">
.notify.alert-warning{
	.close{
		opacity: 1;
		border: 12px -4px 0 0;
	}
}
.connection-alert{
	background: $white;
	border: solid 1px $warning;
	border-radius: 3px;

	.title{
		color: $warning;
	}
	.row{
		.col-lg-3,.col-lg-9{
			padding: 0 !important;
		}
	}
	.bg-connect{
		background: $warning;
		text-align: center;
		font-size: 40px;
		color: $white;
		padding: 5px 0;
	}
	.txt-area{
		padding: 15px 10px;

		
	}

}
</style>